module.exports = __webpack_public_path__ + "static/media/YM16_0.860fc21e.jpg";